import React from 'react';
import './Careers.css';
import heroImage from '../images/Hero - AdobeStock_1204602389.png';
import CTASection from '../components/CTASection';

function Careers() {
  return (
    <div className="careers-page">
      <section className="careers-hero">
        <div className="hero-overlay">
          <div className="hero-content">
            <p className="hero-tagline">Zibit helps your team plan smarter, execute better, and prove results.</p>
            <h1>We Help Teams Make Trade Shows Work Better.</h1>
            <button className="cta-button">Get Started</button>
          </div>
        </div>
      </section>

      <section className="careers-content">
        <div className="content-container">
          <h2>Careers</h2>
          <p className="careers-intro">
            We're always looking for great people. Check out our open positions below!
          </p>

          <div className="quiz-banner">
            <p>Is your trade-show spend pulling its weight?</p>
            <p className="quiz-cta">Take our 2-minute ROI Quiz and get your score now.</p>
            <div className="quiz-link">Take Quiz 📋</div>
          </div>

          <div className="job-listing">
            <h3>1. Product Designer <span className="job-type">(Remote / Full-time)</span></h3>
            
            <div className="job-section">
              <h4>Overview:</h4>
              <p>
                We're looking for a creative, user-centered Product Designer to help us shape 
                intuitive, efficient, and elegant trade show management experiences.
              </p>
            </div>

            <div className="job-section">
              <h4>Responsibilities:</h4>
              <ul>
                <li>Design end-to-end features from wireframes to final visuals</li>
                <li>Collaborate with PM and engineering teams to implement designs</li>
                <li>Conduct user testing and iterate based on feedback</li>
                <li>Maintain consistency and usability in Zibit design system</li>
              </ul>
            </div>

            <div className="job-section">
              <h4>Qualifications:</h4>
              <ul>
                <li>2+ years of UI/UX or product design</li>
                <li>Strong portfolio demonstrating interaction and visual design</li>
                <li>Fluent in Figma, prototyping tools</li>
                <li>Familiarity with design systems and accessibility principles</li>
              </ul>
            </div>

            <button className="apply-button">Apply Today</button>
          </div>

          <div className="job-listing">
            <h3>2. Full Stack Engineer <span className="job-type">(Remote / Contract)</span></h3>
            
            <div className="job-section">
              <h4>Overview:</h4>
              <p>
                We're looking for a versatile engineer to help us build and scale the Zibit platform, 
                including API integrations and dashboard tools.
              </p>
            </div>

            <div className="job-section">
              <h4>Responsibilities:</h4>
              <ul>
                <li>Build responsive front-end interfaces (React preferred)</li>
                <li>Work with the design team to implement smooth user flows</li>
                <li>Optimize performance and ensure secure infrastructure</li>
                <li>Integrate with REST APIs and cloud deployment</li>
                <li>3+ years of full-stack development experience</li>
              </ul>
            </div>

            <div className="job-section">
              <h4>Qualifications:</h4>
              <ul>
                <li>Experience with REST APIs and cloud deployment</li>
                <li>Familiarity with databases (MongoDB, PostgreSQL)</li>
                <li>Bonus: experience in event/booking platforms</li>
              </ul>
            </div>

            <button className="apply-button">Apply Today</button>
          </div>

          <div className="job-listing">
            <h3>3. Marketing & Community Lead <span className="job-type">(Remote / Part-time)</span></h3>
            
            <div className="job-section">
              <h4>Overview:</h4>
              <p>
                Join us as the voice of Zibit—building a presence, growing our community, and 
                supporting product awareness through creative campaigns.
              </p>
            </div>

            <div className="job-section">
              <h4>Responsibilities:</h4>
              <ul>
                <li>Manage content calendar across social channels</li>
                <li>Write blog posts, case studies, and newsletters</li>
                <li>Organize webinars or live events with industry partners</li>
                <li>Track performance metrics and refine outreach strategies</li>
              </ul>
            </div>

            <div className="job-section">
              <h4>Qualifications:</h4>
              <ul>
                <li>2+ years in digital marketing or content creation</li>
                <li>Excellent writing and communication skills</li>
                <li>Comfortable with email marketing and basic analytics</li>
                <li>Bonus: experience in B2B SaaS or event tech</li>
              </ul>
            </div>

            <button className="apply-button">Apply Today</button>
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}

export default Careers;